export const banquets = [
  {
    id: 'grand-ballroom',
    name: 'The Grand Ballroom',
    image:
      'https://images.unsplash.com/photo-1519167758481-83f550bb49b3?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    images: [
      'https://images.unsplash.com/photo-1519167758481-83f550bb49b3?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
      'https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?ixlib=rb-4.0.3&auto=format&fit=crop&w=1169&q=80',
    ],
    desc: 'Our most magnificent space, featuring crystal chandeliers, soaring ceilings, and a private terrace. Ideal for grand weddings, gala dinners, and large corporate events.',
    longDesc:
      'The Grand Ballroom is the crown jewel of Andhra Social & Cultural Association. With its soaring ceilings, magnificent crystal chandeliers, and floor-to-ceiling windows, it provides a breathtaking setting for any major event. The space includes a private pre-function foyer and opens out onto a sweeping terrace overlooking the grounds. It is fully equipped with state-of-the-art audiovisual capabilities and a dedicated banquet kitchen to ensure flawless service for up to 350 guests.',
    capacity: 'Up to 350 guests',
    size: '450 sq m',
    keyDetails: [
      { label: 'Capacity', value: '350 Reception / 250 Banquet' },
      { label: 'Area', value: '450 sq m' },
      { label: 'Features', value: 'Private Terrace, Built-in AV, Dance Floor' },
    ],
  },
  {
    id: 'kakatiya-hall',
    name: 'Kakatiya Hall',
    image:
      'https://images.unsplash.com/photo-1511795409834-ef04bbd61622?ixlib=rb-4.0.3&auto=format&fit=crop&w=1169&q=80',
    images: [
      'https://images.unsplash.com/photo-1511795409834-ef04bbd61622?ixlib=rb-4.0.3&auto=format&fit=crop&w=1169&q=80',
    ],
    desc: 'An elegant, wood-paneled room exuding classic charm. Perfect for mid-sized receptions, anniversary celebrations, and formal banquets.',
    longDesc:
      'Steeped in history, the Kakatiya Hall features rich mahogany paneling, a grand marble fireplace, and historic portraits. It offers an atmosphere of refined elegance and intimacy, making it the perfect choice for mid-sized gatherings such as anniversary dinners, rehearsal dinners, and formal corporate banquets. The room benefits from abundant natural light during the day and a warm, inviting glow in the evening.',
    capacity: 'Up to 120 guests',
    size: '180 sq m',
    keyDetails: [
      { label: 'Capacity', value: '120 Reception / 80 Banquet' },
      { label: 'Area', value: '180 sq m' },
      { label: 'Features', value: 'Historic Fireplace, Natural Light' },
    ],
  },
  {
    id: 'boardroom',
    name: 'The Executive Boardroom',
    image:
      'https://images.unsplash.com/photo-1497366216548-37526070297c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1169&q=80',
    images: [
      'https://images.unsplash.com/photo-1497366216548-37526070297c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1169&q=80',
    ],
    desc: 'A sophisticated space equipped with modern AV technology, designed for high-level meetings, private dining, and intimate gatherings.',
    longDesc:
      'The Executive Boardroom provides a distinguished setting for high-level meetings, strategic planning sessions, and intimate private dining. Centered around a magnificent polished mahogany table that seats up to 20, the room is equipped with discreet, cutting-edge presentation technology and high-speed connectivity. Dedicated service staff ensure that your meeting or dinner proceeds seamlessly and privately.',
    capacity: 'Up to 20 guests',
    size: '45 sq m',
    keyDetails: [
      { label: 'Capacity', value: '20 Boardroom / 20 Private Dining' },
      { label: 'Area', value: '45 sq m' },
      { label: 'Features', value: 'Video Conferencing, Private Service' },
    ],
  },
]

export const getBanquetBySlug = (slug: string) =>
  banquets.find((b) => b.id === slug)
